// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import UserList from './components/Users/UserList';
import UserDetails from './components/Users/UserDetails';
import DocumentVerification from './components/Verification/DocumentVerification';
import PhotoVerification from './components/Verification/PhotoVerification';
import PaymentList from './components/Payments/PaymentList';
import PackageManager from './components/Payments/PackageManager';
import ReportList from './components/Reports/ReportList';
import Settings from './components/Settings/Settings';
import { CircularProgress, Box } from '@mui/material';
import UserPackageManager from './components/Payments/UserPackageManager';
import UserPackageAssignment from './components/Payments/UserPackageAssignment';
import AssignUserPackage from './components/Payments/AssignUserPackage';
import PushNotification from './components/Notifications/PushNotification';
import LocationManager from './components/Location/LocationManager';
import WorkingAsManager from './components/Settings/WorkingAsManager';
import QualificationManager from './components/Settings/QualificationManager';
import WorkingWithManager from './components/Settings/WorkingWithManager';
import ReligionManager from './components/Settings/ReligionManager';
import UserMatching from './components/Matching/UserMatching';
import HobbiesManager from './components/Settings/HobbiesManager';
import AddNewUser from './components/Users/AddNewUser';
import AddNewUserWizard from './components/Users/AddNewUserWizard';
import CoverPhotoApproval from './components/CoverPhotoApproval';
import BannersManagement from './components/BannersManagement';
import StatisticsDashboard from './components/StatisticsDashboard'; // Correct import
//InteractionsDashboard
import InteractionsDashboard from './components/InteractionsDashboard'; // Correct import

import ChatDashboard from './components/ChatDashboard'; // Correct import

//ChatDashboard
 // Correct import

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  const token = localStorage.getItem('adminToken');
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  if (!admin && !token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="matching" element={<UserMatching />} />
            <Route path="users" element={<UserList />} />
            <Route path="users/:id" element={<UserDetails />} />
            <Route path="verification/documents" element={<DocumentVerification />} />
            <Route path="verification/photos" element={<PhotoVerification />} />
            <Route path="payments/transactions" element={<PaymentList />} />
            <Route path="payments/packages" element={<PackageManager />} />
            <Route path="payments/user-packages" element={<UserPackageManager />} />
            <Route path="payments/assign-package" element={<AssignUserPackage />} />
            <Route path="notifications" element={<PushNotification />} />
            <Route path="location" element={<LocationManager />} />
            <Route path="working-as" element={<WorkingAsManager />} />
            <Route path="qualifications" element={<QualificationManager />} />
            <Route path="working-with" element={<WorkingWithManager />} />
            <Route path="religion" element={<ReligionManager />} />
            <Route path="hobbies" element={<HobbiesManager />} />
            <Route path="users/add" element={<AddNewUserWizard />} />
            <Route path="/cover-page" element={<CoverPhotoApproval />} />
            <Route path="/banner" element={<BannersManagement />} /> {/* Updated route */}
            <Route path="reports" element={<ReportList />} />
            <Route path="settings" element={<Settings />} />
            <Route path="statics" element={<StatisticsDashboard />} />
            <Route path="statics/details" element={<InteractionsDashboard />} />
            <Route path="chat/dashboard" element={<ChatDashboard />} />

   

        

          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;